module.exports = __webpack_public_path__ + "static/Header2-d720f0c4b92f20743f40ba9daeabb50b.jpg";